// Rotating copy decks so repeat use never feels canned.

export const LOADING_LINES = [
  "Interrogating the milk…",
  "Calculating decay…",
  "Consulting the leftovers…",
  "Counting the squatters…",
  "Cross-examining the cheese…",
  "Following a suspicious yoghurt…",
  "Measuring the fridge's guilt…",
  "Reading the room. It's cold in here…",
  "Dusting the condiments for prints…",
  "Questioning a very old lemon…",
  "Comparing notes with the butter…",
  "Checking alibis. The eggs are nervous…",
  "Reviewing the crisper drawer footage…",
  "Weighing the evidence. Mostly cheese…",
  "Assembling the case against the ketchup…",
];

export const CAPTURE_TIPS = [
  "Open the door. Let the fridge confess.",
  "Hold steady. The lasagne is watching.",
  "Get the whole shelf in frame.",
  "Good light, honest fridge.",
  "No staging. We want the truth.",
];

export const NARRATOR_INTROS = [
  "The fridge has agreed to talk.",
  "We reviewed the footage. It's grim.",
  "Evidence logged. Brace yourself.",
  "A cold case, warming up.",
  "The shelves have been read their rights.",
];

export function pick(arr, seed) {
  if (seed == null) return arr[Math.floor(Math.random() * arr.length)];
  return arr[seed % arr.length];
}

export const STATUS_META = {
  gone: { label: "Gone", color: "var(--gone)", verb: "vanished" },
  new: { label: "New", color: "var(--new)", verb: "appeared" },
  still_here: { label: "Still here", color: "var(--squatter)", verb: "lingering" },
};
